const selectedStopIcon = require('assets/images/map/stop-selected.svg')
const defaultStopIcon = require('assets/images/map/icono-mapa-actual.png')

export default {
  methods: {
    /*
     * Asigna el marcador creado a un punto de venta
     */
    onStopMarkerAdd(marker) {
      const iconOptions = marker.target?.options?.icon?.options;
      if (!iconOptions || !iconOptions.data || !iconOptions.data.id) {
        return;
      }
    
      const stop = _.find(
        this.mapFilteredStops, s => s.id === iconOptions.data.id
      );
    
      if (stop) {
        this.$set(stop, 'marker', marker);
      }
    },

    

    stopIcon(stop) {
      // Verifica si el stop tiene un operador de tipo "bike" y configura su icono
      if (stop.operator_type === "bike") {
        return L.divIcon({
          html: `
              <div class="valenbisi-icon">
                <div class="valenbisi-logo">
                  <img src="${stop.logo_url}" alt="Valenbisi" />
                  <span class="valenbisi-count">${stop.bikesAvailable || 0}</span>
                </div>
              </div>
          `,
          className: "bike-style-icon", // Clase personalizada para estilos
          iconSize: [33, 33], // Tamaño total del icono
          iconAnchor: [16, 16], // Punto de anclaje
          options: {
            data: { id: stop.id }, // Incluye el id del stop
          },
        });
      }
    
      // Configuración por defecto
      let stopClass = "stop-mini";
      let stopAnchor = [12, 12];
      let stopUrl = this.isGc ? defaultStopIcon : this.isValidUrl(stop.logo_url) ? stop.logo_url : defaultStopIcon;
    
      // Cambia el ícono si el stop es el seleccionado
      if (this.selectedStop?.id === stop.id) {
        stopClass += " selected";
        stopAnchor = [15, 15];
        stopUrl = this.isGc ? defaultStopIcon : this.isValidUrl(stop.logo_url) ? stop.logo_url : selectedStopIcon;
      }
    
      // Define un nuevo ícono para los stops regulares
      const icon = L.icon({
        iconUrl: stopUrl,
        className: stopClass,
        iconAnchor: stopAnchor,
        iconSize: [30, 30], // Tamaño predeterminado
        options: {
          data: { id: stop.id }, // Incluye el id del stop aquí también
        },
      });
      
      // Crear un div que envuelve al ícono
      const wrappedIcon = L.divIcon({
        className: this.selectedStop?.id === stop.id ? "custom-wrapper selected" : "custom-wrapper", // Clase personalizada para el div
        html: `
          <div class="icon-wrapper">
            ${icon.createIcon().outerHTML} <!-- Renderiza el HTML del icon -->
          </div>
        `,
        iconAnchor: stopAnchor, // Define el ancla del div
      });
      
      // Retorna el divIcon
      return wrappedIcon;
      
    },
    
    isValidUrl(url) {
      if (!url) return false;
      try {
        new URL(url); // Intenta construir una URL
        return true; // Si se construye, es válida
      } catch (e) {
        return false; // Si falla, no es válida
      }
    }
    
  }
}
